import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';
@Directive({
  selector: '[clickDelay]'
})
export class clickDelayDirective {
  constructor(private el: ElementRef, private renderer: Renderer2) {}
  @Input('clickDelay') elementHideTimer: number
  @HostListener('click', ['$event']) public onClick( $event: any) {
     this.el.nativeElement.style.visibility = 'hidden';

     setTimeout(() => {
      this.el.nativeElement.style.visibility = 'visible';
    }, this.elementHideTimer);

    }
}
